var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAurora = function SvgAurora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1283.82,
    height: 2112.82,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 1283.82 2112.82"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1187.41 1494.68c0-288.14-112.52-1242.999-251.323-1242.999-138.802 0-251.324 954.859-251.324 1242.999s112.522 521.73 251.324 521.73 251.323-233.59 251.323-521.73"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M805.214 1339.41c0-288.14-72.595-1243-162.145-1243s-162.144 954.86-162.144 1243 72.594 521.73 162.144 521.73 162.145-233.59 162.145-521.73"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M599.059 773.408c0 288.142-112.522 1243.002-251.324 1243.002S96.411 1061.55 96.411 773.408c0-288.14 112.521-521.724 251.324-521.724 138.802 0 251.324 233.584 251.324 521.724"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 734.565,
    x2: 1704.35,
    y1: 2550.15,
    y2: 1846.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79EDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518DEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 513.055,
    x2: 1296.48,
    y1: 2394.88,
    y2: 2028.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9179FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A751EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 48.926,
    x2: 1100.15,
    y1: 359.875,
    y2: 1148.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC60B9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 695.469,
    height: 1957.55,
    x: 588.352,
    y: 155.27,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_0_59",
    stdDeviation: 48.206
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 517.111,
    height: 1957.55,
    x: 384.514,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_0_59",
    stdDeviation: 48.206
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 695.469,
    height: 1957.55,
    x: 0,
    y: 155.273,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_0_59",
    stdDeviation: 48.206
  })))));
};
export default SvgAurora;